/** JS representation of all typeography tokens. Note: these should be kept in sync with the source of truth for typography tokens in partials/_typography.scss */
export var QuiTextSizeEnum;
(function (QuiTextSizeEnum) {
    QuiTextSizeEnum["TextXs"] = "text-xs";
    QuiTextSizeEnum["TextSm"] = "text-sm";
    QuiTextSizeEnum["TextMd"] = "text-md";
    QuiTextSizeEnum["TextLg"] = "text-lg";
    QuiTextSizeEnum["TextXl"] = "text-xl";
    QuiTextSizeEnum["DisplayXs"] = "display-xs";
    QuiTextSizeEnum["DisplaySm"] = "display-sm";
    QuiTextSizeEnum["DisplayMd"] = "display-md";
    QuiTextSizeEnum["DisplayLg"] = "display-lg";
    QuiTextSizeEnum["DisplayXl"] = "display-xl";
    QuiTextSizeEnum["Display2Xl"] = "display-2xl";
})(QuiTextSizeEnum || (QuiTextSizeEnum = {}));
export var QuiFontWeightEnum;
(function (QuiFontWeightEnum) {
    QuiFontWeightEnum["Normal"] = "normal";
    QuiFontWeightEnum["Medium"] = "medium";
    QuiFontWeightEnum["Bold"] = "bold";
})(QuiFontWeightEnum || (QuiFontWeightEnum = {}));
export const QuiLineHeightsPx = {
    "text-xs": 18,
    "text-sm": 20,
    "text-md": 24,
    "text-lg": 28,
    "text-xl": 30,
    "display-xs": 32,
    "display-sm": 38,
    "display-md": 44,
    "display-lg": 60,
    "display-xl": 72,
    "display-2xl": 90,
};
